export enum Locale {
  EN = "en",
  ES = "es",
}

export const defaultLocale = Locale.EN;
export const localeCookieName = "language-selection";

export function normalizeLocale(value: unknown): Locale {
  return value === Locale.ES ? Locale.ES : defaultLocale;
}
